<template>
    <div class="layout">
        <div class="layout__inner">
            <div class="layout__floor">
                <ul class="layout__floor-list">
                    <li :class="{'layout__floor-item': true, 'active': one.placeNm == current.placeNm}" v-for="one in this.depthList['1']" :key="one">
                        <button type="button" @click="getLookAroundList(2, one)">{{one.placeNm}}</button>
                        <ul class="layout__floor-sub-list">
                            <li :class="{'layout__floor-sub-item': true, 'active': two.placeNm == current.floor}" v-for="two in this.depthList['2']" :key="two">
                                <button @click="getLookAroundList(3, two)">{{two.placeNm}}</button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="layout__info">
                <div class="layout__store">
                    <h4 class="layout__store-tit">{{current.floor}}</h4>
                    <ul class="layout__store-list">
                        <template v-for="pin in pinArr" :key="pin">
                            <li :class="{'layout__store-item': true, 'active': pin.name == current.name}" v-if="pin.floor.split('_')[2] == current.floor && pin.floor.indexOf(current.placeNm) > -1">
                                <button type="button" @click="setCurrent(pin)"><span>{{pin.floor_num}}</span>{{pin[clsfLang()]}}</button>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="layout__map">
                    <div class="pin" v-show="showPin"><img src="@/assets/resource/icon/pin.svg" alt="이미지"></div>
                    <img :src="`/displayFile.do?name=${ img.attachBag.lookAroundPhoto[0].savedName }`" :alt="img.attachBag.lookAroundPhoto[0].altValue" v-if="img?.attachBag?.lookAroundPhoto" @load="imageLoad">
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            depthList:{},
            place:null,

            img: '',
            pinArr: [],
            current: {},

            showPin: false,

            popupShow: false,
            firstCallFlag: true,
            imgLoad: false,
        }
    },
    methods: {
        clsfLangKo(){
            const lang = this.$store.getters.getLang
            let result = '영문'
            if(lang == 'en'){
                result = '영문'
            }else if(lang == 'ar'){
                result = '아랍어'
            }else if(lang == 'mn'){
                result = '몽골어'
            }else if(lang == 'ru'){
                result = '러시아어'
            }else if(lang == 'zh'){
                result = '중문'
            }
            return result
        },
        clsfLang(){
            const lang = this.$store.getters.getLang
            let result = 'en'
            if(lang == 'ar'){
                result = 'arab'
            }else if(lang == 'zh'){
                result = 'cn'
            }else if(lang == 'mn'){
                result = 'mon'
            }else{
                result = lang
            }
            return result + '_name'
        },
        imageLoad(){
            this.imgLoad = true
        },
        popupBtn() {
            this.popupShow = !this.popupShow
        },
        getLookAroundList(depth, item){
            var params = {
                hospId: this.$store.getters.getHost
            }
            if(item) params.parentPlaceCd = item.placeCd;
            this.axios
                .get(this.api.lookAround.lookAroundList, {params})
                .then(res => {
                    this.depthList[depth] = res.data.list;
                    var totCnt = res.data.totCnt;

                    if(totCnt == 0 && (depth == 0 || depth == 1)){
                        return
                    }

                    if(totCnt > 0){
                        if(depth == 0){
                            for(let i of this.depthList[depth]){
                                if(i.placeNm == this.clsfLangKo()){
                                    this.getLookAroundList(depth + 1, i);
                                    break
                                }
                            }
                        }else{
                            this.getLookAroundList(depth + 1, this.depthList[depth][0]);
                        }
                    }else{
                        this.getLookAround(item.placeCd);
                    }

                    if(depth == 2 && !this.firstCallFlag){
                        this.current.placeNm = item.placeNm;
                    }

                    if(depth == 3){
                        if(this.firstCallFlag){
                            this.getPin();
                            this.current.placeNm = this.depthList['1'][0].placeNm;
                            for(let [index, i] of this.depthList['2'].entries()) {
                                if (index == 0) {
                                    this.firstCallFlag = false;
                                    this.getImg(i);
                                    break;
                                }
                            }
                        }else{
                            this.getImg(item);
                        }
                    }
                })
        },
        getImg(item){
            this.axios.get(this.api.lookAround.lookAround, {
                params: {
                    hospId: this.$store.getters.getHost,
                    placeCd: item.placeCd,
                }
            }).then(res => {
                this.img = res.data.query;
                this.$nextTick(() => {
                    const move = setInterval(() => {
                        if(this.pinArr.length > 0 && this.imgLoad) {
                            this.setCurrent(item);
                            clearInterval(move);
                        }
                    }, 100);
                    setTimeout(() => {
                        clearInterval(move);
                    }, 2000);
                })
            })
        },
        getLookAround(placeCd){
            this.axios
                .get(this.api.lookAround.lookAround,
                    {
                        params: {
                            hospId: this.$store.getters.getHost,
                            placeCd: placeCd,
                        }
                    })
                .then(res => {
                    this.place = res.data.query;
                })
        },
        getPin(){
            this.axios.get(this.api.lookAround.pinList, {
                params: {
                    hospId: this.$store.getters.getHost
                }
            })
            .then(res => {
                this.pinArr = res.data;

                this.pinArr = this.pinArr.map(i => {
                    if(i.floor.indexOf('본관') > -1){
                        return {...i, floor: i.floor.replace('본관', 'Main Building')}
                    }else if(i.floor.indexOf('A관') > -1){
                        return {...i, floor: i.floor.replace('MCC A관', 'MCC A Building')}
                    }else if(i.floor.indexOf('B관') > -1){
                        return {...i, floor: i.floor.replace('MCC B관', 'MCC B Building')}
                    }
                    return i
                });
            })
        },
        setCurrent(item){
            var floor = item.placeNm ? item.placeNm : item.floor.split('_')[2];
            var name = item.name;
            var x = item.x;
            var y = item.y;
            if(name == null){
                for(let i of this.pinArr){
                    if(i.floor.indexOf(this.current.placeNm) > -1 && i.floor.indexOf(floor) > -1){
                        name = i.name;
                        x = i.x;
                        y = i.y;
                        break;
                    }
                }
            }
            
            this.current = { floor: floor, name: name, x: x, y: y, placeNm: this.current.placeNm };
            
            if(this.current.x != null && this.current.y != null){
                const move = setInterval(() => {
                    if($('.pin').length > 0) {
                        this.showPin = true
                        this.simpleMove(this.current.x, this.current.y);
                        clearInterval(move);
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(move);
                }, 2000);
            }else{
                this.showPin = false
            }
        },
        simpleMove(x, y){
            if (x != null && y != null) {
                if($('.layout__map  > img').length == 0) return
                let width = Number($('.layout__map  > img').css("width").replace('px', ''))
                let height = Number($('.layout__map  > img').css("height").replace('px', ''))
                if(width == 0) width = window.innerWidth > 1024 ? window.innerWidth * 0.56 : window.innerWidth - 51;
                let pointerX = Number($('.pin > img').css("width").replace('px', '')) || 52;
                let pointerY = Number($('.pin > img').css("height").replace('px', '')) || 66;

                const value = 0
                let xC = (width / 900) * Number(x) - pointerX / 2
                let yC = ((height / 800) * Number(y) - pointerY) + value
                
                if (this.showPin) {
                    $('.pin').animate({ top: yC, left: xC }, 1000);
                } else {
                    $('.pin').animate({ top: yC, left: xC }, 0);
                }
            }
        },
    },
    mounted() {
        this.getLookAroundList(0);
    },
}
</script>